// Sorting table rows by a column, for SortableTable.jsx. Kept out of the component so it can
// be run by the tests without a JSX build.
//
// Empty values (null, undefined, '') always go last, whichever way round, so reversing a
// sort never fills the top of the table with blanks.

export const isBlank = (v) => v == null || v === '' || (typeof v === 'number' && Number.isNaN(v));

export function compareValues(a, b) {
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  return String(a).localeCompare(String(b), 'en-GB', { numeric: true, sensitivity: 'base' });
}

export function sortRows(rows, valueOf, dir) {
  if (!valueOf) return rows;
  const sign = dir === 'desc' ? -1 : 1;
  // Decorated so each value is computed once, and the original index breaks ties, which
  // keeps rows that sort equal in the order the server sent them.
  return rows
    .map((row, i) => ({ row, i, v: valueOf(row) }))
    .sort((x, y) => {
      const xb = isBlank(x.v), yb = isBlank(y.v);
      if (xb || yb) return xb === yb ? x.i - y.i : xb ? 1 : -1;
      return sign * compareValues(x.v, y.v) || x.i - y.i;
    })
    .map(d => d.row);
}
